import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * A section's catch-all: sends an unknown page such as `/budget/top-sheet` to the section's
 * default page, keeping the query string and anchor.
 *
 * The app runs React Router with `v7_relativeSplatPath`, so a plain `<Navigate to="breakdown">`
 * in a `*` route resolves below the unknown path (`/budget/top-sheet/breakdown`), which is
 * unknown too, and the redirect loops forever. This resolves against the section instead, by
 * dropping the unmatched segments.
 */
export const SectionRedirect = ({ to }: { to: string }) => {
  const { pathname, search, hash } = useLocation();
  const unmatched = (useParams()["*"] ?? "").split("/").filter(Boolean).length;
  const segments = pathname.split("/").filter(Boolean);
  const section = segments.slice(0, segments.length - unmatched).join("/");
  return <Navigate to={{ pathname: `/${section}/${to}`, search, hash }} replace />;
};
